import React from 'react';
import useSocket from '../socket/useSocket';
import { invalidateQueue } from '../../services/queue';
import useUser from '../global/useUser';
import { userHasAccessToQueue } from '../../helpers/queue';

interface MessageData {
  appointmentId: string;
  source: 'customer' | 'business';
}

function useQueueSocket() {
  const socket = useSocket();
  const { user } = useUser();

  const isQueueEnabled = React.useMemo(
    () => !!user && userHasAccessToQueue(user),
    [user],
  );

  React.useEffect(() => {
    if (!isQueueEnabled) return undefined;

    const onNewWalkIn = (data: MessageData) => {
      if (data.source !== 'customer') return;
      invalidateQueue();
    };

    socket.on('newQueuedWalkIn', onNewWalkIn);

    return () => {
      socket.off('newQueuedWalkIn', onNewWalkIn);
    };
  }, [socket, isQueueEnabled]);
}

export default useQueueSocket;
